<template>
  <div class="statusPage">
    <h1>设备指标<span>（货道状态，库存数量，库存状态为实时数据，每整点更新一次）</span></h1>

    <div class="pageTop">
      <!-- <h2 class="countrySel">地区选择</h2>
      <el-select v-model="region" placeholder="请选择">
        <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <h2>景区</h2>
      <SearchSelect
          v-model="store"
          :options="allStore"
          :props="{
         label: 'name',
         value: 'id'
      }"
          placeholder="请选择景区"
      />
      <h2>设备</h2>
      <SearchSelect
          v-model="device"
          :options="filterDevices"
          :props="{
           label: 'name',
           value: 'id'
      }"
          placeholder="请选择设备"
      />
    </div>
    <div class="pageTop">


      <h2>状态</h2>
      <el-select v-model="stock" placeholder="请选择" >
        <el-option
            v-for="item in stockOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <h2>年份</h2>
      <el-date-picker
          v-model="dateValue"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
          :clearable="false"
      >
      </el-date-picker>
      <h2>趋势图指标筛选</h2>
      <el-select class="mineSelect" v-model="quota" placeholder="请选择" >
        <el-option
            v-for="item in quotaOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="handleQuery">查询</el-button>
      <el-button @click="handleDownload" icon="el-icon-download">下载</el-button>
    </div>

    <div class="pageTable">
      <Table ref="quota" :params="params"></Table>
      <EchartsEight ref="trend" :params="params"></EchartsEight>
    </div>

  </div>
</template>

<script>
import Table from './QuotaTable'
import EchartsEight from "./EchartsEight";
import SearchSelect from "@/views/components/SearchSelect";
import { getDeviceDownload, getDeviceList } from "@/api/bi"


export default {
  name: "DeviceQuota",
  data(){
    return {
      region: '0', // 国家
      countryList: [
        { value: '0', label: '全部' },
        { value: '1', label: '中国大陆' },
        { value: '2', label: '中国香港' },
        { value: '3', label: '中国澳门' },
        { value: '4', label: '中国台湾' },
        { value: '5', label: '阿联酋' },
        { value: '6', label: '美国' },
        { value: '7', label: '韩国' },
      ],
      store: '',
      category: ["1", "2", "3","4","5","6","7","8"],
      options: [
        { value: '1', label: '771/772' },
        { value: '2', label: '775' },
        { value: '3', label: '776' },
        { value: "4", label: "779" },
        { value: "5", label: "780" },
        { value: "6", label: "781" },
        { value: "7", label: "782" },
        { value: "8", label: "783" }
      ],
      device: '',
      dateValue: [], //
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          // time.getTime() > 明天零点时间戳 → 禁用
          return time.getTime() > Date.now();
        }
      },
      quota: '1',
      quotaOptions: [
        { value: '1', label: '设备销售额' },
        { value: '2', label: '退款率' },
      ],
      stock: '0',
      stockOptions: [
        { value: '0', label: '全部' },
        { value: '1', label: '货道充足' },
        { value: '2', label: '货道缺货' },
        { value: '3', label: '货道售罄' },
        { value: '4', label: '货道关闭' },
      ],
      filterDevices: this.allDevice instanceof Array? this.allDevice : [], // 经过景区筛选后的设备列表(默认是全部的设备)
    }
  },
  created(){
    this.setRangeDates();
  },
  props: ['allStore', 'allDevice'], // 全部景区列表、设备列表
  methods:{
    setRangeDates() {
      // const today = new Date();
      // const year = today.getFullYear();
      // const month = today.getMonth(); // 月份从0开始，0为1月
      // const day = today.getDate();

      // let startDate, endDate;

      // if (month === 0 && day === 1) {
      //   // 如果今天是1月1日，起始和结束日期为去年12月的1号和31号
      //   startDate = new Date(year - 1, 11, 1);
      //   endDate = new Date(year - 1, 11, 31);
      // } else if (day === 1) {
      //   // 如果今天是一个月的1号，起始日期为上一个月的1号，结束日期为上一个月的最后一天
      //   startDate = new Date(year, month - 1, 1);
      //   endDate = new Date(year, month, 0); // 设置日期为0将自动设置为上个月的最后一天
      // } else {
      //   // 如果今天是一个月中的其他日期，起始日期为这个月的1号，结束日期为昨天
      //   startDate = new Date(year, month, 1);
      //   endDate = new Date(year, month, day - 1);
      // }

      // this.dateValue = [this.formatDate(startDate), this.formatDate(endDate)]
      const today = new Date() // 获取当前时间
      today.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为当天的 00:00:00.000
      const currentDate = new Date()
      currentDate.setHours(23, 59, 59, 999) // 设置时、分、秒、毫秒为最大值，即将时间设置为当天的 23:59:59.999

      this.dateValue = [this.formatDate(today), this.formatDate(currentDate)] // 设置当前时间范围
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    handleQuery(){
      // 查询
      this.$refs.quota.fetchData(); // 调用子组件的方法
      this.$refs.trend.initData(); // 调用子组件的方法
    },
    handleDownload(){
      const params = {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        company_id_list: this.store || undefined, // 景区id
        device_id_list: this.device || undefined, // 景区id
        tp: this.quota || undefined, // 指标筛选
        type: this.stock,
      }
      this.$confirm(`确认下载数据吗？`).then(() => {
        // 下载
        getDeviceDownload(params).then((data) => {
          this.download(data);
        })
            .catch((error) => {
              this.$message.error(error);
            });
      })
    },
    download(resp) {
      const fileName = '设备状态';
      const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },

    dateChange(val){
      const [ start, end ] = val;
      console.log(start, end)
      console.log(this.dateValue)
    },
  },
  computed: {
    params(){ // 父组件调用table子组件中的方法
      return {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        company_id_list: this.store || undefined, // 景区id
        device_id_list: this.device || undefined, // 景区id
        tp: this.quota || undefined, // 指标筛选
        type: this.stock,
      }
    },
  },
  watch:{
    store(newVal, oldVal){
      // 检测景区变化，就更新设备
      // 根据景区搜索设备
      if(newVal.length === 0){
        this.filterDevices = this.allDevice instanceof Array? this.allDevice : [] // 防止没有数据的时候，是{} 不是[]
      } else {
        const params = { company_id_list: newVal }
        getDeviceList(params).then(res =>{
          console.log(res)
          this.filterDevices = res.data instanceof Array? res.data : []
        })
      }
    }
  },
  components: {
    Table,
    EchartsEight,
    SearchSelect
  },
}
</script>

<style scoped>

/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58D9F9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7CFFB2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}


.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.statusPage h1{
  margin-right: 30px;
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: bold;
}

.statusPage h1 span {
  font-size: 18px;
  font-weight: normal;
}

.pageTop h2{
  margin: 0 10px;
}

.pageTop .mineSelect {
  margin: 0 10px;
}

.statusPage,
.deviceBox{
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  border: 1px solid #5c01b8;
  border-radius: 30px;
  width: 95%;
  margin: 10px auto;

}

.statusPage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
  margin-top: 30px;
}

.pageTable {
  margin-top: 40px;
}
.el-button {
  margin-left: 10px;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;

}
</style>